import React, { useState } from 'react';
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Row,
  Col,
} from 'reactstrap';
import { generateAffiliateLink } from '../../helpers/affiliateTracking';

const LinkGenerator = ({ affiliate }) => {
  const [linkData, setLinkData] = useState({
    source: 'direct',
    campaign: 'default',
  });
  const [generatedLink, setGeneratedLink] = useState('');
  const [copied, setCopied] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLinkData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGenerateLink = () => {
    const baseUrl = window.location.origin + '/index';
    const link = generateAffiliateLink(
      affiliate?.code,
      baseUrl,
      linkData.source,
      linkData.campaign,
    );
    setGeneratedLink(link);
    setCopied(false);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(generatedLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Error copying link:', error);
    }
  };

  return (
    <Card>
      <CardBody>
        <h5 className="card-title mb-3">Generatore Link Affiliazione</h5>

        <Form>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="source">Fonte</Label>
                <Input
                  id="source"
                  name="source"
                  type="text"
                  value={linkData.source}
                  onChange={handleInputChange}
                  placeholder="es. facebook, instagram, email"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="campaign">Campagna</Label>
                <Input
                  id="campaign"
                  name="campaign"
                  type="text"
                  value={linkData.campaign}
                  onChange={handleInputChange}
                  placeholder="es. promo2025, blackfriday"
                />
              </FormGroup>
            </Col>
          </Row>

          <div className="d-flex gap-2 mb-3">
            <Button
              color="primary"
              onClick={handleGenerateLink}
              disabled={!affiliate?.id}>
              <i className="bx bx-link mr-1" />
              Genera Link
            </Button>
          </div>

          {generatedLink && (
            <Alert color="info">
              <div className="d-flex justify-content-between align-items-center">
                <div className="flex-grow-1">
                  <strong>Link generato:</strong>
                  <div className="mt-2">
                    <code className="text-break">{generatedLink}</code>
                  </div>
                </div>
                <Button
                  color="success"
                  size="sm"
                  onClick={handleCopyLink}
                  className="ml-2">
                  <i className={`bx ${copied ? 'bx-check' : 'bx-copy'}`} />
                  {copied ? 'Copiato!' : 'Copia'}
                </Button>
              </div>
            </Alert>
          )}

          <div className="mt-3">
            <small className="text-muted">
              <strong>Note:</strong> Il link generato traccerà le conversioni
              per 60 giorni dal primo click. Solo il primo acquisto di ogni
              utente genererà una commissione.
            </small>
          </div>
        </Form>
      </CardBody>
    </Card>
  );
};

export default LinkGenerator;
